import axios from "axios";

// Import logging interceptors
import setupApiInterceptors from '../Utils/ApiInterceptor';

// Create axios instances
const loginInstance = axios.create({
    // baseURL: 'http://192.168.1.6:4000/api/',
    // baseURL: 'http://localhost:4000/api/',
    // baseURL: 'http://3.101.135.248/api/',
    baseURL: process.env.REACT_APP_BASE_URL + '/api/',
    headers: {
        "Content-Type": "application/json",
        timeout: 1000,
    }
});

//OLD INSTANCE KEPT FOR REFRENCE BY KUNAL
// const instance = () => {
//     const token = sessionStorage.getItem('token');

//     return axios.create({
//         // baseURL: 'http://192.168.1.6:4000/api/',
//         baseURL: 'http://localhost:4000/api/',
//         // baseURL: 'http://3.101.135.248/api/',
//         // baseURL: process.env.REACT_APP_BASE_URL + '/api/',
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `${token}`,
//             timeout: 1000,
//         }
//     })
// }

// const socketURL = 'http://192.168.1.6:4000';
// const socketURL = 'http://3.101.135.248/';

const instance = axios.create({
    // baseURL: 'http://192.168.1.6:4000/api/',
    // baseURL: 'http://localhost:4000/api/',
    // baseURL: 'http://3.101.135.248/api/',
    baseURL: process.env.REACT_APP_BASE_URL + '/api/',
    headers: {
        "Content-Type": "application/json",
        Authorization: `${sessionStorage.getItem('token')}`,
        timeout: 1000,
    }
});

// Configure logging - simplified to use only BatchedLogger
const LOGGING_CONFIG = {
    enabled: process.env.REACT_APP_ENABLE_LOGGING !== 'false',
    logLevel: process.env.REACT_APP_LOG_LEVEL || 'info'
};

// Setup logging interceptors using BatchedLogger
if (LOGGING_CONFIG.enabled) {
    // Use BatchedLogger for all API logging
    setupApiInterceptors(loginInstance);
    setupApiInterceptors(instance);
    console.log('BatchedLogger API logging enabled');
} else {
    console.log('API logging disabled via configuration');
}

const socketURL = process.env.REACT_APP_BASE_URL;

const apis = {
    loginInstance,
    instance,
    socketURL,
    // Export configuration for debugging
    loggingConfig: LOGGING_CONFIG
};

export default apis;